import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { LandingV2 } from './pages/LandingV2';
import { LandingV3 } from './pages/LandingV3';
import { LandingV4 } from './pages/LandingV4';
import { LandingV5 } from './pages/LandingV5';
import { LandingV6 } from './pages/LandingV6';
import { LandingVInt } from './pages/LandingVInt';
export function AppRouter() {
  return <BrowserRouter data-id="element-1">
      <Routes data-id="element-2">
        {/* /vint → international digital-only version */}
        <Route path="/vint" element={<LandingVInt data-id="element-4" />} data-id="element-3" />
        {/* /v2 → always LandingV2, direct access */}
        <Route path="/v2" element={<LandingV2 data-id="element-6" />} data-id="element-5" />
        {/* /v3 → always LandingV3, direct access */}
        <Route path="/v3" element={<LandingV3 data-id="element-8" />} data-id="element-7" />
        {/* /v4 → always LandingV4, direct access */}
        <Route path="/v4" element={<LandingV4 data-id="element-10" />} data-id="element-9" />
        {/* /v5 → always LandingV5, direct access */}
        <Route path="/v5" element={<LandingV5 data-id="element-12" />} data-id="element-11" />
        {/* /v6 → always LandingV6, direct access */}
        <Route path="/v6" element={<LandingV6 data-id="element-14" />} data-id="element-13" />
        {/* / → split test (controlled by index.tsx) */}
        <Route path="/*" element={<App data-id="element-16" />} data-id="element-15" />
      </Routes>
    </BrowserRouter>;
}